<div class="steps a-fx">
    <div class="steps-progress" [style.width]="progressWidth$ | async">
        <div class="steps-progress-bar" [style.width.%]="progressBarWidth$ | async"></div>
    </div>

    <div
        *ngFor="let step of steps$ | async; trackBy: trackByStep"
        class="step a-fx-col a-fx-flex a-fx-center-center a-fx-gap-8"
    >
        <div class="caption-2" [ngClass]="step.active || step.completed ? 'a-color-light-blue' : 'a-color-disabled'">
            {{ step.title }}
        </div>

        <div class="step-dot" [class.completed]="step.completed" [class.active]="step.active"></div>
    </div>
</div>
